import React, { useEffect, useState } from "react"
import CramLayout from "./CramLayout";
import { Navigate, Outlet, useNavigate, useLocation } from "react-router-dom"
import { HomeOutlined, PhoneOutlined, FormOutlined, NotificationOutlined, ReadOutlined } from '@ant-design/icons';
import axios from "axios";
import MediaLayout from './MediaLayout';
import { Breadcrumb, Layout, Menu, theme } from 'antd';
const { Header, Content, Sider } = Layout;

const AdminMediaTab = (props) => {
    // const { auth, role, path } = useAuth()
    const [nav, setNav] = useState([]);
    const [li, setLi] = useState([]);
    const [identity, setIdentity] = useState([])
    const navigate = useNavigate();

    function getItem(label, key, icon, children, disabled, type) {
        return {
            key,
            icon,
            children,
            label,
            disabled,
            type
        };
    }
    const get_identity = () => {
        axios
            .get(`/cramSchool/api/permission`,)
            .then((response) => {
                setIdentity(response.data)
            })
    }
    useEffect(() => {
        get_identity();
    }, [])
    useEffect(() => {
        if (props.topic == 'admin') {
            setNav(
                []
            )
            setLi([
                getItem('Mercy後台管理', "/cramSchool/admin", <HomeOutlined />),
                getItem('形象推廣管理模組', 'blog', <NotificationOutlined />, [
                    getItem('最新消息公告 ', '/cramSchool/admin/Media/News'),
                    getItem('課程介紹內容管理', '/cramSchool/admin/Media/ClassIntroduce'),
                    getItem('上課花絮內容管理', '/cramSchool/admin/Media/Class'),
                    getItem('學習見證內容管理', '/cramSchool/admin/Media/ShareLearning'),
                ]),
                getItem('學習聚寶盒（題庫）', 'test', <ReadOutlined />, [
                    getItem('無框美學', '/cramSchool/admin/Media/Content/2'),
                    getItem('兒童美語', '/cramSchool/admin/Media/Content/3'),
                    getItem('國中初階', '/cramSchool/admin/Media/Content/4'),
                    getItem('國中養成班', '/cramSchool/admin/Media/Content/5'),
                    getItem('國高中進階班', '/cramSchool/admin/Media/Content/6'),
                    getItem('櫃檯夥伴', '/cramSchool/admin/Media/Content/266'),
                    getItem('師德', '/cramSchool/admin/Media/Content/269'),
                    // getItem('影音課程', '/cramSchool/admin/Media/VideoClass'),
                    // getItem('英語課程', '/cramSchool/admin/Media/EnglishCourse'),
                    // getItem('外語測驗', '/cramSchool/admin/Media/ForeignTest'),
                    // getItem('其他測驗', '/cramSchool/admin/Media/OthersTest'),
                ]),
                getItem('手機暫存區', '/cramSchool/admin/Media/Smartphone', <PhoneOutlined />),
                getItem('標籤管理', '/cramSchool/admin/Media/Tag', <FormOutlined />),
                // getItem('授課大綱', null, <FileTextOutlined />, [
                //     getItem('教材管理', '',),
                //     getItem('回家作業', ''),
                //     getItem('隨堂測驗', ''),
                //     getItem('互動式活動', ''),

                //     // getItem('課程點名管理模組', "/cramSchool/admin/RFIDRollCall", null),
                //     // getItem('請假管理模組 ', "/", null),
                // ]),
            ])

        }
    }, [identity]
    )

    return (


        (
            <MediaLayout
                nav={nav}
                li={li}
                setLi={setLi}>
                <Outlet />

            </MediaLayout>
        )

    )
}

export default AdminMediaTab;

